module.exports = __webpack_public_path__ + "img/mapas-tematidcos-tm.14fa6314.png";